import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getProject } from "../../api/projectApi";
import background from "../../assets/img/backgorund.png";
import FooterSection from "../../commponents/layout/Footer";

interface Project {
  id: number;
  projectName: string;
  image: string | null;
  description: string;
  status: string;
}

export default function RecentProjectPage() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const fetchProject = async () => {
    try {
      setLoading(true);

      const response = await getProject({
        page: 1,
        limit: 10,
      });

      setProjects(response.data.projectStructureList);
      setTotalPages(response.data.pagination.totalPages);
      setTotalData(response.data.pagination.totalData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProject();
  }, []);

  return (
    // FIX: min-h-screen di sini -- background image sekarang ngikutin
    // tinggi <main> ini (minimal 1 layar penuh), bukan ngikutin tinggi
    // <section> yang cuma sepanjang kontennya. Kalau konten lebih
    // panjang dari 1 layar (project-nya banyak), background otomatis
    // ikut memanjang juga karena <main> relative & absolute img pakai
    // inset-0 (ngikutin tinggi parent yang sebenarnya, bukan cuma viewport).
    <main className="relative z-0 min-h-screen w-full overflow-hidden">
      {/* BACKGROUND -- dipindah ke sini (bukan di dalam <section>) supaya
          nutupin seluruh <main>, bukan cuma seluas konten section */}
      <img
        src={background}
        alt=""
        className="
          absolute
          inset-0
          z-[-1]
          h-full
          w-full
          object-cover
        "
      />

      {/* OVERLAY -- dipindah bareng background-nya */}
      <div className="absolute inset-0 z-[-1] bg-[#355260]/40" />

      <section
        className="
          relative
          z-10
          w-full
          px-6
          pt-32
          pb-40
          lg:px-20
        ">
        <div className="mx-auto w-full max-w-[1327px]">
          {/* TITLE */}
          <div className="mb-20">
            <h1
              className="
                mb-5
                text-[42px]
                font-bold
                text-white
                lg:text-[64px]
              ">
              Recent Project
            </h1>

            <p
              className="
                max-w-[480px]
                text-[18px]
                leading-[34px]
                text-white/90
              ">
              Portofolio proyek terkini sebagai bukti komitmen kami terhadap
              hasil terbaik.
            </p>
          </div>

          {/* PROJECT GRID */}
          <div
            className="
              grid
              grid-cols-2
              gap-4
              sm:grid-cols-[repeat(auto-fit,minmax(220px,1fr))]
              sm:gap-6
              lg:grid-cols-[repeat(auto-fit,minmax(280px,1fr))]
              lg:gap-8
            ">
            {projects.map((project) => (
              <div
                key={project.id}
                onClick={() => navigate(`/Project/${project.id}`)}
                className="
                  group
                  relative
                  aspect-[280/380]
                  w-full
                  cursor-pointer
                  overflow-hidden
                  rounded-[16px]
                  bg-gray-200
                  transition-transform
                  duration-300
                  hover:-translate-y-1
                  hover:shadow-xl
                ">
                {/* IMAGE */}
                {project.image ? (
                  <img
                    src={project.image}
                    alt={project.projectName}
                    className="
                      absolute
                      inset-0
                      h-full
                      w-full
                      object-cover
                      transition-transform
                      duration-500
                      group-hover:scale-105
                    "
                  />
                ) : (
                  <div
                    className="
                      absolute
                      inset-0
                      flex
                      items-center
                      justify-center
                      bg-gray-200
                      text-gray-400
                    ">
                    No Image
                  </div>
                )}

                {/* GRADIENT */}
                <div
                  className="
                    absolute
                    inset-x-0
                    bottom-0
                    bg-gradient-to-t
                    from-[#324A5A]
                    via-[#324A5A]/70
                    to-transparent
                    p-6
                  ">
                  <h3
                    className="
                      text-[22px]
                      font-bold
                      leading-tight
                      text-white
                      lg:text-[26px]
                    ">
                    {project.projectName}
                  </h3>

                  {project.description && (
                    <p
                      className="
                        mt-2
                        line-clamp-2
                        text-sm
                        text-white/85
                      ">
                      {project.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FooterSection />
    </main>
  );
}
